import { Injectable } from '@angular/core';

import { ConverterService, ProductImageNormalizer } from '@spartacus/core';
import { OccCartNormalizer } from '@spartacus/cart/base/occ';
import { Cart } from '@spartacus/cart/base/root';

import { CustomProductImageNormalizer } from './custom-product-image-normalizer.service';
import { OccCart } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CustomCartNormalizer extends OccCartNormalizer {
  constructor(
    protected superConverter: ConverterService,
    private customImageNormalizer: CustomProductImageNormalizer,
    private productImageNormalizer: ProductImageNormalizer
  ) {
    super(superConverter);
  }

  convert(source: OccCart, target?: Cart): Cart {
    target = super.convert(source, target);
    target.entryGroups =
      source.entryGroups?.map((group) => ({
        ...group,
        medias: this.customImageNormalizer.normalize(group.medias),
        entries: group.entries.map((entry) => ({
          ...entry,
          product: this.productImageNormalizer.convert(entry.product)
        }))
      })) || [];
    return target;
  }
}
